import { useState } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../stores/auth';
import '../../components/layout/siteSwitcher.css';
import { Icon } from '../../components/ui/Icon';
import { ThemeToggle } from '../../components/ui/ThemeToggle';

export function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="dash-shell">
      <button
        type="button"
        className="dash-sidebar-backdrop"
        aria-label="Close navigation"
        data-open={sidebarOpen}
        onClick={() => setSidebarOpen(false)}
      />
      <aside className={`dash-sidebar${sidebarOpen ? ' dash-sidebar--open' : ''}`}>
        <div className="dash-sidebar__header">
          <Link className="dash-logo" to="/dashboard/sites" onClick={() => setSidebarOpen(false)}>
            <span className="dash-logo__mark" aria-hidden="true">◐</span>
            <span>Sarnia Builder</span>
          </Link>
          <button
            type="button"
            className="dash-sidebar__close"
            onClick={() => setSidebarOpen(false)}
            aria-label="Close menu"
          >
            <Icon name="x" size={18} />
          </button>
        </div>

        <nav className="dash-nav" aria-label="Dashboard">
          <NavLink
            to="/dashboard/sites"
            end
            className={({ isActive }) => `dash-nav__link${isActive ? ' dash-nav__link--active' : ''}`}
            onClick={() => setSidebarOpen(false)}
          >
            <Icon name="layout" size={18} />
            <span>My sites</span>
          </NavLink>
          <NavLink
            to="/dashboard/sites/new"
            className={({ isActive }) => `dash-nav__link${isActive ? ' dash-nav__link--active' : ''}`}
            onClick={() => setSidebarOpen(false)}
          >
            <Icon name="plus" size={18} />
            <span>Create site</span>
          </NavLink>
          <NavLink
            to="/templates"
            className={({ isActive }) => `dash-nav__link${isActive ? ' dash-nav__link--active' : ''}`}
            onClick={() => setSidebarOpen(false)}
          >
            <Icon name="grid" size={18} />
            <span>Template gallery</span>
          </NavLink>
          <NavLink
            to="/help/getting-started"
            className={({ isActive }) => `dash-nav__link${isActive ? ' dash-nav__link--active' : ''}`}
            onClick={() => setSidebarOpen(false)}
          >
            <Icon name="book" size={18} />
            <span>Guide</span>
          </NavLink>
          <NavLink
            to="/dashboard/account"
            className={({ isActive }) => `dash-nav__link${isActive ? ' dash-nav__link--active' : ''}`}
            onClick={() => setSidebarOpen(false)}
          >
            <Icon name="user" size={18} />
            <span>Account</span>
          </NavLink>
          <NavLink
            to="/dashboard/account/billing"
            className={({ isActive }) => `dash-nav__link${isActive ? ' dash-nav__link--active' : ''}`}
            onClick={() => setSidebarOpen(false)}
          >
            <Icon name="star" size={18} />
            <span>Plans</span>
          </NavLink>
        </nav>

        <div className="dash-sidebar__footer">
          <a className="dash-studio-link" href="https://sarnia.digital/">
            <Icon name="home" size={16} />
            <span>Back to sarnia.digital</span>
          </a>
          <div className="dash-user-chip">
            <span className="dash-avatar" aria-hidden="true">
              {(user?.email?.[0] ?? 'U').toUpperCase()}
            </span>
            <span className="dash-user-meta">
              <span className="dash-user-email">{user?.email}</span>
              <button type="button" className="dash-signout" onClick={handleLogout}>
                Sign out
              </button>
            </span>
          </div>
        </div>
      </aside>

      <div className="dash-main">
        <header className="dash-topbar">
          <button
            type="button"
            className="dash-menu-btn"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <Icon name="menu" size={20} />
          </button>
          <div className="dash-topbar__title">Sarnia Builder</div>
          <div className="dash-topbar__actions">
            <ThemeToggle />
          </div>
        </header>
        <main className="dash-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
